import React from 'react';
import ProgressIndicator from '../../ProgressIndicator/ProgressIndicator';
import CartIndex from '../CartPartials/CartIndex';
import UserForm from '../../User/UserForm';
import AccountForm from '../../Account/AccountForm';
import PropertyForm from '../../Property/Property/PropertyForm';
import PaymentForm from '../CartPartials/PaymentForm';
import CartSuccess from '../CartPartials/CartSuccess';
import OrderSummaryCard from '../CartPartials/OrderSummaryCard';
import ContactInfoCard from '../../ContactInfo/ContactInfoCard/ContactInfoCard';

export default class CartContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			userId: null,
			accountId: null,
			propertyId: null,
			firstName: null,
			lastName: null,
			email: null,
			phoneNumber: null,
			isOnCartIndex: true,
			isOnUserForm: false,
			isOnAccountForm: false,
			isOnPropertyForm: false,
			isOnPaymentForm: false,
			isOnCartSuccess: false
		};

		this.goToCartIndex = this.goToCartIndex.bind(this);
		this.goToUserForm = this.goToUserForm.bind(this);
		this.goToAccountForm = this.goToAccountForm.bind(this);
		this.goToPropertyForm = this.goToPropertyForm.bind(this);
		this.goToPaymentForm = this.goToPaymentForm.bind(this);
		this.goToSuccess = this.goToSuccess.bind(this);
	}

	render() {
		// console.log('CartContainer', this.props);
		// console.log('CartContainer', this.state);
		let percentCompete;
		if (this.state.isOnUserForm) {
			percentCompete = 20;
		} else if (this.state.isOnAccountForm) {
			percentCompete = 40;
		} else if (this.state.isOnPropertyForm) {
			percentCompete = 60;
		} else if (this.state.isOnPaymentForm) {
			percentCompete = 80;
		} else if (this.state.isOnCartSuccess) {
			percentCompete = 100;
		}

		return (
			<div className="CartContainer mx-auto">
				<div className="mx-auto grid grid-cols-1 lg:grid-cols-12 w-full lg:w-11/12">
					<div className="lg:col-span-7">
						<div className="w-full lg:w-5/6">
							<div>
								{!this.state.isOnCartIndex ? (
									<ProgressIndicator percentComplete={percentCompete} />
								) : (
									''
								)}
							</div>
							<div>
								{this.state.isOnCartIndex ? (
									<CartIndex continueLocation={this.goToUserForm} />
								) : this.state.isOnUserForm ? (
									<UserForm
										continueLocation={this.goToAccountForm}
										backLocation={this.goToCartIndex}
										create_user_endpoint={this.props.create_user_endpoint}
									/>
								) : this.state.isOnAccountForm ? (
									<AccountForm
										userId={this.state.userId}
										continueLocation={this.goToPropertyForm}
										backLocation={this.goToUserForm}
										create_account_endpoint={this.props.create_account_endpoint}
									/>
								) : this.state.isOnPropertyForm ? (
									<PropertyForm
										accountId={this.state.accountId}
										firstName={this.state.firstName}
										lastName={this.state.lastName}
										phoneNumber={this.state.phoneNumber}
										email={this.state.email}
										continueLocation={this.goToPaymentForm}
										backLocation={this.goToAccountForm}
										create_property_endpoint={
											this.props.create_property_endpoint
										}
										create_property_ownership_endpoint={
											this.props.create_property_ownership_endpoint
										}
										create_power_of_attorney_endpoint={
											this.props.create_power_of_attorney_endpoint
										}
										create_business_license_survey_endpoint={
											this.props.create_business_license_survey_endpoint
										}
										create_subscription_endpoint={
											this.props.create_subscription_endpoint
										}
									/>
								) : this.state.isOnPaymentForm ? (
									<PaymentForm
										propertyId={this.state.propertyId}
										firstName={this.state.firstName}
										lastName={this.state.lastName}
										continueLocation={this.goToSuccess}
										backLocation={this.goToPropertyForm}
										endpoint={this.props.create_payment_account_endpoint}
									/>
								) : this.state.isOnCartSuccess ? (
									<CartSuccess />
								) : (
									''
								)}
							</div>
						</div>
					</div>
					<div className="md:col-span-5 w-full">
						<div>
							<OrderSummaryCard hasBorder={true} />
						</div>
						<div className="md:col-span-5 w-full mt-6">
							<ContactInfoCard hasBorder={true} />
						</div>
					</div>
				</div>
			</div>
		);
	}

	goToCartIndex() {
		this.setState({
			isOnCartIndex: true,
			isOnUserForm: false,
			isOnAccountForm: false,
			isOnPropertyForm: false,
			isOnPaymentForm: false,
			isOnCartSuccess: false
		});
	}

	goToUserForm() {
		this.setState({
			isOnCartIndex: false,
			isOnUserForm: true,
			isOnAccountForm: false,
			isOnPropertyForm: false,
			isOnPaymentForm: false,
			isOnCartSuccess: false
		});
	}

	goToAccountForm(userId, firstName, lastName, email) {
		this.setState({
			userId: userId,
			firstName: firstName,
			lastName: lastName,
			email: email,
			isOnCartIndex: false,
			isOnUserForm: false,
			isOnAccountForm: true,
			isOnPropertyForm: false,
			isOnPaymentForm: false,
			isOnCartSuccess: false
		});
	}

	goToPropertyForm(accountId, phoneNumber) {
		this.setState({
			accountId: accountId,
			phoneNumber: phoneNumber,
			isOnCartIndex: false,
			isOnUserForm: false,
			isOnAccountForm: false,
			isOnPropertyForm: true,
			isOnPaymentForm: false,
			isOnCartSuccess: false
		});
	}

	goToPaymentForm(propertyId) {
		this.setState({
			propertyId: propertyId,
			isOnCartIndex: false,
			isOnUserForm: false,
			isOnAccountForm: false,
			isOnPropertyForm: false,
			isOnPaymentForm: true,
			isOnCartSuccess: false
		});
	}

	goToSuccess() {
		this.setState({
			isOnCartIndex: false,
			isOnUserForm: false,
			isOnAccountForm: false,
			isOnPropertyForm: false,
			isOnPaymentForm: false,
			isOnCartSuccess: true
		});
	}
}
